// API URL resolver - always use current origin to avoid cross-domain cookie issues
const API_URL = window.location.origin;

export default API_URL;
